import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Grid from '../../components/Grid'
import request from '../../utils/request'
import PatientButton from './PatientButton'
import Input from "../../components/Input"
import Text from "../../components/Text"

export const LoadingIcon = styled.div`
  width: 100%;
  font-size: 2rem;
  color: var(--gray);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`

const FilterParentDiv = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  justify-content: flex-end;
`

const FilterInputDiv = styled.div`
  flex: 1 1 15em;
  flex-shrink: 0;
  margin: 0.5rem;
`

const FilterButtonDiv = styled.div`
  margin: 0.5rem;
  align-self: flex-end;
`

@observer
export default class List extends Component {
  @observable loading = true
  @observable patientList = []
  @observable filterText = ""
  @observable filterStrings = []

  @action
  setPatientList = list => {
    this.patientList = list
    this.loading = false
  }

  @action
  setFilter = event => {
    this.filterText = event.target.value
    this.filterStrings = this.filterText.split(" ").map(f => f.toLowerCase())
  }

  getPatientList = async () => {
    const res = await request('/api/user/getPatientList')

    if (res.success) {
      this.setPatientList(res.data.patientList)
    }
  }

  componentDidMount() {
    this.getPatientList()
  }

  render() {
    const { toggleAddPatient } = this.props
    
    if (this.loading) {
      return <LoadingIcon className="fas fa-sync fa-spin" />
    }

    const filteredList = !this.loading && this.patientList
      .filter(p => {
        // Include this patient in the display if the filter is empty
        if (!this.filterStrings.length) {
          return true
        }

        // ...or if one of the space separated filter strings is found in the patient's name
        for (const s of this.filterStrings) {
          if (p.name.toLowerCase().includes(s)) {
            return true
          }
        }

        // Otherwise, hide the patient from display
        return false
      })
      .map((patient, i) => (
        <Grid.HalfCell key={i}>
          <PatientButton {...patient} />
        </Grid.HalfCell>
      ))

    return (
      <div>
        <FilterParentDiv>
          {/* <span
            style={{
              margin: "0 auto 0 0",
              color: "#aaa",
              fontStyle: "italic",
            }}
          >
            {this.filterText && (
              `${filteredList.length} matching patient${filteredList.length === 1 ? '' : 's'}`
            )}
          </span> */}
          <FilterInputDiv>
            <Input
              label="titles.filterByName"
              value={this.filterText}
              onChange={this.setFilter}
              style={{
                background: "white",
                fontSize: "calc(12px + 0.25vw)",
                padding: "0.5em",
                flex: "0",
                border: `1px solid ${this.filterText ? "#0788D9" : "#ccc"}`,
              }}
            />
          </FilterInputDiv>
          <FilterButtonDiv>
            <button
              style={{
                padding: "0.5em 1em",
                color: "white",
                background: this.loading ? "#ccc" : "#0788D9",
                cursor: this.loading ? "default" : "pointer",
                alignSelf: "flex-end",
                fontSize: "calc(12px + 0.25vw)",
                border: "1px solid transparent",
              }}
              disabled={this.loading}
              onClick={toggleAddPatient}
            >
              + <Text str="titles.addNewPatient" />
            </button>
          </FilterButtonDiv>
        </FilterParentDiv>
        <Grid>
          {/* {this.filterText === "" && (
            <Grid.HalfCell>
              <OutlineButton
                  icon="fas fa-user-plus"
                  str="titles.addNewPatient"
                  onClick={toggleAddPatient}
                />
            </Grid.HalfCell>
          )} */}
          {!this.loading && filteredList}
          {/* If the filtered list is empty, display some message explaining why */}
          {!this.loading && !filteredList.length && (
            <div
              style={{
                textAlign: "center",
                color: "#999",
                fontSize: "1.5em",
                width: "100%",
                margin: "2rem 0 0 0",
              }}
            >
              <Text
                str={this.filterText
                  ? "No patients with that name were found"
                  : "Your organization doesn't have any patients yet"
                }
              />
            </div>
          )}
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Patients/List.js